export default {
  title: 'Debug',

  titles: {
    sendings: 'Last sending',
    textFields: 'g-text-field variants',

    reset: {
      all: 'Full reset',
      storage: 'Storage reset',
      cache: 'Cache reset',
      serviceWorker: 'Service worker recovery',
      report: 'Reset result'
    }
  },

  labels: {
    version: 'Platform version',
    newVersion: 'Available version',
    date: 'Date and time',
    dateUTC: 'Date and time UTC',
    timeZone: 'Time zone',
    utcOffset: 'UTC offset',
    locale: 'Interface locale',
    viewport: 'Window size',
    screen: 'Screen size',
    pixelRatio: 'Pixel ratio',
    userAgent: 'User agent',
    standalone: 'Running as PWA',
    host: 'Host',
    protocol: 'Protocol',
    apiURL: 'API address',
    socketURL: 'WebSocket address',
    route: 'Route',
    routeName: 'Route name',
    online: 'Network',
    connection: 'Connection type',
    cookieEnabled: 'Cookies',
    indexedDB: 'IndexedDB',
    caches: 'Cache Storage',
    storageUsage: 'Storage usage',
    storageQuota: 'Storage quota',
    localStorageSize: 'localStorage size',
    isLoggedAs: 'Logged in as user',

    ws: 'WebSocket',
    serviceWorker: 'Service worker',

    frontend: {
      title: 'Platform name'
    },

    browser: {
      name: 'Name',
      version: 'Version'
    },

    account: {
      username: 'Username',
      balance: 'Balance',
      id: 'ID',
      reseller: 'Owner ID',
      permissions: 'Permissions count',
      sendingTypes: 'Message types'
    },

    sending: {
      id: 'ID',
      recipient: 'Recipient',
      type: 'Sending type'
    },

    textFields: {
      outline: 'Outline mode',
      outlineLabel: 'Outline-label mode',
      lineLabel: 'Line-label mode'
    },

    reset: {
      socket: 'WebSocket connection',
      localStorage: 'localStorage',
      sessionStorage: 'sessionStorage',
      cookies: 'Cookies',
      serviceWorker: 'Service worker',
      cacheStorage: 'Cache Storage',
      indexedDB: 'IndexedDB'
    }
  },

  contents: {
    reset: {
      all: 'Token, settings, favorites, cookies, caches and browser databases will be removed.<br>A localStorage snapshot is downloaded to a file before cleaning.<br><strong class="mt-2">Are you sure you want to continue?</strong>',
      storage: 'Token, settings, favorites and cookies will be removed.<br>A localStorage snapshot is downloaded to a file before cleaning.<br><strong class="mt-2">Are you sure you want to continue?</strong>',
      cache: 'Caches and browser databases will be removed.<br>Token and settings are preserved.<br><strong class="mt-2">Are you sure you want to continue?</strong>',
      serviceWorker: 'Service worker registrations and browser caches will be removed.<br>Token, settings and databases are preserved.<br>The page will be loaded again.<br><strong class="mt-2">Are you sure you want to continue?</strong>'
    }
  },

  info: {
    download: {
      storage: '<strong>Copy of the stored data</strong><br>Saves the contents of the local storage to a file - the data that the platform keeps on this computer. Nothing is removed or changed.<br>Send the file to support if they ask for details about the state of the platform.'
    },

    reset: {
      serviceWorker: '<strong>Background handler recovery</strong><br>Removes the registration of the page background handler and the stored copies of the platform files. Sign in, settings and databases stay in place, the page is loaded again and the handler is registered anew.<br>Suitable when the platform opens in an outdated form or updates do not appear after a page reload.',
      cache: '<strong>Reset of the stored copies</strong><br>Removes the stored copies of the platform files and its databases. Sign in and settings stay, a repeated sign in is not required. The page does not reload by itself, refresh it after the reset.<br>Suitable when sections show outdated data or do not open.',
      storage: '<strong>Storage reset</strong><br>Removes sign in, settings, favorites and site service files, the interface language is preserved. The stored copies of the files and the databases stay. A copy of the local storage is downloaded to a file before cleaning, a repeated sign in is required after the reset.<br>Suitable when the platform works unexpectedly after an account or settings change.',
      all: '<strong>Full reset</strong><br>Removes everything the platform keeps on this computer: sign in, settings, favorites, site service files, stored copies of the files and databases, the interface language is preserved. A copy of the local storage is downloaded to a file before cleaning, a repeated sign in is required after the reset.<br>The last resort when the other ways did not help.'
    }
  },

  reset: {
    done: 'Done',
    skipped: 'Skipped',
    failed: 'Error'
  },

  ws: {
    connected: 'Connected',
    disconnected: 'Disconnected'
  },

  serviceWorker: {
    unsupported: 'Not supported by the browser',
    unregistered: 'Not registered',
    installing: 'Update is installing',
    waiting: 'Update is downloaded and waits to be applied'
  },

  values: {
    yes: 'Yes',
    no: 'No',
    unavailable: 'Unavailable'
  },

  buttons: {
    reset: {
      all: 'Reset',
      storage: 'Reset',
      cache: 'Reset',
      serviceWorker: 'Restore'
    },

    download: {
      storage: 'Download'
    },

    clean: {
      storage: 'Clean storage'
    }
  }
}
